import { graphql, type GetLicenseInfo$result } from '$houdini'
import { refreshSessionLicenseInfo } from 'stores/session'
import { applySessionToStore } from 'utility/session-helper'

const loginMutation = graphql(`
	mutation Login($userName: String!, $passPhrase: String!, $storeId: UInt!) {
		createSession(user: $userName, password: $passPhrase, storeId: $storeId) {
			token
			id
			userName
			currentUserAccountId
			accessType
			accessStatus
			sessionStatus
			storeId
			recordType
			recordId
			...Permissions
			companyInfo {
				id
			}
			userAccount {
				...SessionUserAccount
			}
		}
	}
`)

export type LicenseLimit = GetLicenseInfo$result['licenseInfo']['limits'][number]
export type LicenseToggle = GetLicenseInfo$result['licenseInfo']['toggles'][number]

interface MakeLoginRequest {
	username: string
	password: string
	storeId: number
}

export async function makeLoginRequest({ username, password, storeId: storeIdParam }: MakeLoginRequest): Promise<string> {
	const res = await loginMutation.mutate({
		userName: username,
		passPhrase: password,
		storeId: storeIdParam,
	})

	if (!res?.data?.createSession?.token || !res.data.createSession.userAccount) {
		throw new Error('Invalid Login')
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { token, userAccount, companyInfo, storeId, ' $fragments': _fragments, permissions, ...session } = res.data.createSession

	//I know this seems dumb, but I need to type narrow these and you can't type narrow object props
	if (!userAccount || !companyInfo?.id || !storeId) {
		throw new Error('Invalid Login')
	}

	applySessionToStore({
		sessionBase: session,
		userAccount,
		sessionPermissions: permissions,
		companyId: companyInfo.id,
		storeId,
		authToken: token,
	})

	// licenses are an authorized endpoint, so fetch it after we set the first part of the session
	await refreshSessionLicenseInfo()

	return token
}
